/* Component Dependencies */
var groupPromotionTemplate = require('templates/groupPromotion.hbs');
var AriesComponent = require('libs/aries-component');
var ResponsiveUtils = require('utils/responsiveUtils');

AriesComponent.create({
  type: 'groupPromotion',
  template: {
    'groupPromotion': groupPromotionTemplate
  },
  bindEvents: function() {
  	this.responsiveUtils = ResponsiveUtils.create();
    this.responsiveUtils.init();
  	var _self = this;
  	if(this.responsiveUtils.isMobile()) {
  	$(window).scroll(function(){
      if($('#stickySummary').hasClass('is-sticky-top')){
        _self.addMargin();
      }else {
      	_self.removeMargin();
      }
    });
  	}
  },
  addMargin: function() {
  	this.$el.find('.t-promos-heading').addClass('l-scroll-margin');
  },
  removeMargin: function() {
  	this.$el.find('.t-promos-heading').removeClass('l-scroll-margin');
  }
});
